import { ViewModel } from '../../view-model';
import { CONFIG } from '../../../core/config';

export class ModelVisualCategoryCalibrationList implements ViewModel {
  readonly friendlyTypeNameSingular = 'ModelVisualCategoryCalibrationList';
  readonly apiRoute: string = CONFIG.apiRoutes.ModelCategoryCalibration;

  modelCategoryCalibration: ModelCategoryCalibration[] = new Array<ModelCategoryCalibration>();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.modelCategoryCalibration = new Array<ModelCategoryCalibration>();
    if (data) {
      data.modelCategoryCalibration.forEach(element => {
        const mvc = new ModelCategoryCalibration();
        mvc.loadFromJson(element);
        this.modelCategoryCalibration.push(mvc);
      });
    }
  }
}

export class ModelCategoryCalibration implements ViewModel {
  readonly friendlyTypeNameSingular = 'ModelVisualCategoryCalibration';
  readonly apiRoute: string = CONFIG.apiRoutes.ModelCategoryCalibration;

  modelCategoryCalibrationId: string;
  riskMatrixCalibrationsId: string;
  riskMatrixConsequenceVectorId: string;
  riskMatrixProbabilityVectorId: string;
  index: number;
  label: string;
  riskMatrixId: string;
  createdBy: string;
  createdDate: string;
  opUpperLimit: string;
  upperLimit: number;
  opLowerLimit: string;
  lowerLimit: number;
  locked: boolean;
  lockedDate: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.modelCategoryCalibrationId = data.modelCategoryCalibrationId;
    this.createdBy = data.createdBy;
    this.createdDate = data.createdDate;
    this.index = data.index;
    this.label = data.label;
    this.riskMatrixCalibrationsId = data.riskMatrixCalibrationsId;
    this.riskMatrixConsequenceVectorId = data.riskMatrixConsequenceVectorId;
    this.riskMatrixId = data.riskMatrixId;
    this.riskMatrixProbabilityVectorId = data.riskMatrixProbabilityVectorId;
    this.lowerLimit = data.lowerLimit;
    this.opLowerLimit = data.opLowerLimit;
    this.opUpperLimit = data.opUpperLimit;
    this.upperLimit = data.upperLimit;
    this.locked = data.locked;
    this.lockedDate = data.lockedDate;
  }
}
